// ===================================================================
// KAIXO - CRMAgents
// ===================================================================
// Vista 'agents' del CRM: lista de agentes + panel expandible para
// añadir un nuevo agente (seleccionando un usuario KAIXO y su rol).
// ===================================================================

import React from 'react';
import { Icons } from '../Icons/Icons';
import ct from './i18n';

export default function CRMAgents({
    agents,
    currentUser,
    allKaixoUsers,
    showAddAgent,
    onToggleAddAgent,
    newAgentId,
    onNewAgentIdChange,
    newAgentRole,
    onNewAgentRoleChange,
    onAddAgent,
    onAssignUnassigned,
    onOpenDetail
}) {
    const availableUsers = allKaixoUsers.filter(
        u => String(u._id) !== String(currentUser?._id)
            && !agents.some(a => String(a.user?._id) === String(u._id))
    );

    return (
        <>
            <div style={{ display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap' }}>
                <button className="crm-btn-primary" onClick={onToggleAddAgent}>
                    <Icons.Plus size={14} color="white" /> {ct.addAgent}
                </button>
                <button
                    className="crm-btn-secondary-sm"
                    onClick={onAssignUnassigned}
                    title="Asigna todos los leads sin asignar a los agentes activos (round-robin)"
                >
                    <Icons.Users size={13} /> Asignar pendientes
                </button>
            </div>

            {showAddAgent && (
                <div className="crm-add-agent-form">
                    <select
                        value={newAgentId}
                        onChange={e => onNewAgentIdChange(e.target.value)}
                        className="crm-filter"
                        style={{ flex: 1 }}
                    >
                        <option value="">-- {ct.addAgent} --</option>
                        {availableUsers.map(u => (
                            <option key={u._id} value={u._id}>
                                {u.name} ({u.language})
                            </option>
                        ))}
                    </select>
                    <select
                        value={newAgentRole}
                        onChange={e => onNewAgentRoleChange(e.target.value)}
                        className="crm-filter"
                    >
                        <option value="admin">Admin</option>
                        <option value="agent">Agente</option>
                        <option value="viewer">Viewer</option>
                    </select>
                    <button
                        className="crm-btn-primary"
                        onClick={onAddAgent}
                        disabled={!newAgentId}
                    >
                        <Icons.Check size={14} color="white" />
                    </button>
                </div>
            )}

            {agents.length === 0 ? (
                <p className="crm-center crm-dim">{ct.noActivity}</p>
            ) : (
                agents.map(a => (
                    <div
                        key={a._id}
                        className="crm-agent-card crm-agent-card-clickable"
                        onClick={() => onOpenDetail(a._id)}
                    >
                        <div className="crm-agent-avatar">
                            {a.user?.avatar
                                ? <img src={a.user.avatar} alt="" loading="lazy" decoding="async" />
                                : (a.user?.name?.[0] || '?').toUpperCase()}
                        </div>
                        <div className="crm-agent-info">
                            <div className="crm-agent-name">{a.user?.name || '—'}</div>
                            <div className="crm-agent-role">
                                <span className="crm-role-badge">{a.role}</span>
                                {' · '}{a.points || 0} {ct.points}
                            </div>
                        </div>
                        <Icons.ChevronRight size={16} color="var(--text-secondary)" />
                    </div>
                ))
            )}
        </>
    );
}
